import ClosedPrograms from './ClosedPrograms.vue';

const components = [ClosedPrograms];

export default components;



// WEBPACK FOOTER //
// ./src/components/closed-programs/index.js